import { render } from "./PageEditor.vue?vue&type=template&id=a72e9362&scoped=true"
import script from "./PageEditor.vue?vue&type=script&lang=js"
export * from "./PageEditor.vue?vue&type=script&lang=js"

import "./PageEditor.vue?vue&type=style&index=0&id=a72e9362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72e9362"]])

export default __exports__